import React from 'react';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/MessagePage.css';

export default function PrincipalMessage() {
  return (
    <Layout bannerTitle="Principal's Message">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Message from the Principal" />
          <div className="row g-5 mt-2 align-items-start">
            <div className="col-lg-4 text-center">
              <div className="message-page-photo-wrapper">
                <div className="message-page-photo-placeholder">
                  <i className="fas fa-user-circle"></i>
                </div>
                {/* [PLACEHOLDER: Replace with actual principal photo] */}
                <h4 className="mp-name">Geeta Rani</h4>
                <p className="mp-designation">Principal</p>
                <p className="mp-school">Akash Model Sr. Sec. School</p>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="message-page-content">
                <p className="message-opening">Dear Students, Parents, and Well-Wishers,</p>
                <p>
                  It gives me immense pleasure to welcome you to Akash Model Sr. Sec. School — a place
                  where dreams take shape and futures are built. For over three decades, this institution
                  has stood as a beacon of academic excellence, moral values, and holistic development.
                </p>
                <p>
                  Education is not merely about acquiring degrees; it is about building character,
                  developing critical thinking, and preparing young minds for the challenges of tomorrow.
                  Our school's motto — <strong>"Work Is Worship"</strong> — inspires every member of
                  our community to give their best in everything they do.
                </p>
                <p>
                  We are committed to providing a safe, stimulating, and nurturing environment where
                  every child can discover their unique potential. Our team of dedicated educators
                  works tirelessly to ensure that students receive the best possible education,
                  both inside and outside the classroom.
                </p>
                <p>
                  I invite parents to be active partners in their child's educational journey.
                  Together, we can make a lasting difference in the lives of our students.
                </p>
                <p className="message-sign-off">With warm regards,</p>
                <div className="message-signature">
                  <strong>Geeta Rani</strong>
                  <span>Principal, Akash Model Sr. Sec. School</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
